export const DAYS_IN_WEEK = 7;
export const MONTHS_IN_YEAR = 12;
export const DAYS_IN_YEAR = 365;
export const WEEKS_IN_YEAR = 52;
export const DAY = 'day';
export const DAYS = 'days';
export const WEEK = 'week';
export const WEEKS = 'weeks';
export const MONTH = 'month';
export const MONTHS = 'months';
export const MONTH_ABBR = 'mo';
export const YEAR = 'year';
export const YEARS = 'years';
export const YEAR_ABBR = 'yr';

export const SECONDS_PER_MINUTE = 60;
export const SECONDS_PER_HOUR = SECONDS_PER_MINUTE * 60;
export const SECONDS_PER_DAY = 24 * SECONDS_PER_HOUR;
export const MILLISECONDS_PER_SECOND = 1000;
export const MILLISECONDS_PER_MINUTE = SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND;

export const FIVE_MINUTES_IN_MINUTES = 5;

/** Device ID cookie expiration: 400 days in seconds. */
export const DEVICE_ID_COOKIE_MAX_AGE_SEC = 400 * SECONDS_PER_DAY;
